<template>
  <div class="about">
    <div class="title">
      当前位置: <span class="home-page" @click="toHomePage()">首页</span> > <span>{{ title }}</span>
    </div>
    <div class="content">
      <div class="left">
        <div class="tab" :class="{ active: activeTab == index }" @click="changeTab(index, item.text)" v-for="(item, index) in tabs" :key="item.text">
          <img :src="item.img1" alt="" v-show="activeTab != index" />
          <img :src="item.img2" alt="" v-show="activeTab == index" />
          <div>{{ item.text }}</div>
        </div>
      </div>
      <div class="right" v-if="activeTab == 0">
        <div class="about-title">
          <img src="./img/content.png" alt="" />
          <div>{{ aboutWe.title }}</div>
        </div>
        <div class="right-content">
          <div v-html="aboutWe.profile"></div>
        </div>
      </div>
      <div class="right" v-if="activeTab == 3">
        <div class="feedback-title">标题</div>
        <input type="text" v-model="feedbackTitle" placeholder="请输入标题内容" />
        <div class="title-wrap">
          <div class="feedback-title">内容</div>
          <div class="warning" v-show="isWarning">
            <img src="./img/warning.png" alt="" />
            <div>{{ warning }}</div>
          </div>
        </div>
        <textarea v-model="feedbackContent" placeholder="请输入大于20字的内容"></textarea>
        <div class="btn-wrap">
          <div v-if="feedbackTitle && feedbackContent" @click="submit()" class="btn" style="opacity: 1; cursor: pointer">提交</div>
          <div v-else class="btn">提交</div>
        </div>
      </div>
      <div class="right" v-if="activeTab == 2">
        <div class="protect">
          <img src="./img/protect2.png" alt="" />
          <div class="protect-text">版权投诉</div>
          <div>请添加客服QQ：939004020</div>
        </div>
      </div>
      <div class="right" v-if="activeTab == 4">
        <div class="protect">
          <img src="./img/business2.png" alt="" />
          <div class="protect-text">商务合作</div>
          <div>请添加客服QQ：939004020</div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { post } from "@/util/http";
import { mapState, mapMutations } from "vuex";
import Footer from "@/components/footer/footer";

export default {
  name: "about",
  components: { Footer },
  computed: {
    ...mapState(["userInfo", "appConfig"]),
  },
  data() {
    return {
      tabs: [
        { img1: require("./img/about.png"), img2: require("./img/about_on.png"), text: "关于猎鹰" },
        { img1: require("./img/service.png"), img2: require("./img/service_on.png"), text: "联系客服" },
        { img1: require("./img/protect.png"), img2: require("./img/protect_on.png"), text: "版权保护" },
        { img1: require("./img/feedback.png"), img2: require("./img/feedback_on.png"), text: "意见反馈" },
        { img1: require("./img/business.png"), img2: require("./img/business_on.png"), text: "商务合作" },
      ],
      activeTab: this.$route.params.id,
      title: "关于猎鹰",
      aboutWe: "",
      feedbackTitle: "",
      feedbackContent: "",
      warning: "",
      isWarning: false,
    };
  },
  watch: {
    feedbackContent() {
      this.isWarning = false;
    },
  },
  beforeDestroy() {},
  created() {},

  mounted() {
    this.getBottomData();
    console.log();
  },
  methods: {
    toHomePage() {
      this.$router.push("/");
    },
    changeTab(index, text) {
      this.activeTab = index;
      this.title = text;
      if (this.activeTab == 1) {
        window.open(this.appConfig.service_url, "_blank");
      }
    },
    getBottomData() {
      post({ url: "/api/protocol/getProtocolList" }).then(({ data: { data } }) => {
        this.aboutWe = data[4] || {};
      });
    },
    submit() {
      if (this.feedbackContent.length < 20) {
        this.warning = "请输入大于20字的内容";
        this.isWarning = true;
        return;
      }
      if (this.feedbackContent.length > 500) {
        this.warning = "请输入小于500字的内容";
        this.isWarning = true;
        return;
      }
      post({
        url: "/api/moment/SendFeedback",
        data: {
          title: this.feedbackTitle,
          content: this.feedbackContent,
        },
      }).then(({ data }) => {
        if (data.status === 0) {
          this.$message.success(data.msg);
          this.feedbackTitle = "";
          this.feedbackContent = "";
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.about {
  padding-top: 0.56rem;
}
.title {
  width: 10.8rem;
  margin: 0 auto;
  font-size: 0.14rem;
  color: #666;
  padding: 0.3rem 0 0.15rem 0;
  span {
    color: #02a8a2;
  }
  .home-page {
    color: #333;
    cursor: pointer;
  }
}
.content {
  margin: 0 auto;
  background-color: #fff;
  width: 10.8rem;
  height: 5.6rem;
  border-radius: 0.1rem;
  margin-bottom: 0.24rem;
  display: flex;
}
.left {
  padding-top: 0.24rem;
  width: 1.26rem;
  height: 100%;
  border-right: 0.01rem solid #f0f0f0;
  display: flex;
  flex-direction: column;
  .tab {
    height: 0.42rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666;
    font-size: 0.14rem;
    border-right: 0.01rem solid transparent;
    cursor: pointer;
    img {
      width: 0.2rem;
      height: 0.2rem;
      margin-right: 0.05rem;
    }
  }
  .active {
    color: #02a8a2;
    background: rgba(2, 168, 162, 0.1);
    border-right: 0.01rem solid #02a8a2;
  }
}
.right {
  flex: 1;
  padding: 0.24rem 0.35rem;
  .about-title {
    display: flex;
    align-items: center;
    margin-bottom: 0.2rem;
    img {
      width: 0.28rem;
      height: 0.28rem;
      margin-right: 0.05rem;
    }
    div {
      font-size: 0.14rem;
      color: #666;
    }
  }
  p {
    font-size: 0.14rem;
    color: #666;
    line-height: 0.2rem;
    text-indent: 0.3rem;
  }
  .feedback-title {
    margin: 0.15rem 0;
  }
  .title-wrap {
    display: flex;
    align-items: center;
  }
  .warning {
    display: flex;
    align-items: center;
    margin-left: 0.1rem;
    img {
      width: 0.12rem;
      height: 0.12rem;
      margin-right: 0.03rem;
    }
    div {
      font-size: 0.12rem;
      color: #db6372;
    }
  }
  input {
    width: 95%;
    height: 0.38rem;
    border: 0.01rem solid #f0f0f0;
    border-radius: 0.03rem;
    padding: 0 0.15rem;
    font-size: 0.14rem;
    color: #666;
    outline: none;
    margin-bottom: 0.15rem;
  }
  input::placeholder {
    color: #999;
  }
  textarea {
    width: 95%;
    height: 1rem;
    border: 0.01rem solid #f0f0f0;
    border-radius: 0.03rem;
    padding: 0.1rem 0.15rem;
    font-size: 0.14rem;
    color: #666;
    outline: none;
  }
  textarea::placeholder {
    color: #999;
  }
  .btn-wrap {
    width: 95%;
    text-align: center;
  }
  .btn {
    margin: 0.8rem auto;
    width: 1.08rem;
    height: 0.33rem;
    border-radius: 0.05rem;
    background: linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
    opacity: 0.45;
    color: #fff;
    font-size: 0.14rem;
    line-height: 0.33rem;
    cursor: not-allowed;
  }
  .protect {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 1.5rem;
    font-size: 0.14rem;
    color: #999;
    img {
      width: 1.8rem;
      height: 1.8rem;
    }
    .protect-text {
      font-size: 0.2rem;
      color: #333;
      margin-bottom: 0.12rem;
    }
  }
}
</style>
